import axios from "axios";
import "./../../assets/css/topbar.css";
import "./../../assets/sass/style.css";
import "./../../assets/sass/style.scss";
import { Link } from "react-router-dom";
import "./../../assets/sass/_topbar.scss";
import "./../../assets/sass/_dashboard.scss";
import "./../../Components/FontAwesome/FontAwesome";
import Review from "../../Components/dashboardReview";
import React, { useState, useEffect, useRef } from "react";
import { API_Link, validateHeader } from "../../commons/Constants";
import { TbChartBar, TbChartDots, TbChartArrows } from "react-icons/tb";
import Reviewcard from "./../../Components/dashboardComponent/reviewcard";
import Progressgraph from "./../../Components/dashboardComponent/ReviewerProgress";
import RecentlyCompleted from "../../Components/dashboardComponent/RecentlyCompleted";
import { useSelector } from "react-redux";
function Dashboard(props) {
  const userData = useSelector((state) => state.user.data.role.role);

  const contentRef = useRef(null);
  const MD5hash = validateHeader();
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  ////////---- States ----\\\\\\\
  const [data, setData] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [activeTab, setActiveTab] = useState("review");

  const getReviewArticlesCount = () => {
    var config = {
      method: "get",
      url: `${API_Link}getInProgressReviewArticlesCount`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        setData(APIresponse);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getCompletedArticlesCount = () => {
    var config = {
      method: "get",
      url: `${API_Link}getCompletedReviewArticlesCount`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        setCompleted(APIresponse);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ////////---- useEffect ----\\\\\\\\
  useEffect(() => {
    localStorage.setItem("pageId", 1001);
    if (contentRef.current) {
      contentRef.current.style.setProperty("padding", "5px 20px", "important");
    }
  }, []);
  useEffect(() => {
    getReviewArticlesCount();
    getCompletedArticlesCount();
  }, []);

  ////////---- Inprogress Reviews Count ----\\\\\\\\
  const studies = data?.map((study) => study.title);
  const articlesCount = data?.map((study) => study.articles_count);
  const abstractArticlesCount = data?.map(
    (study) => study.abstract_articles_count
  );
  const fullTextArticlesCount = data?.map(
    (study) => study.fulltext_articles_count
  );
  const includedArticlesCount = data?.map(
    (study) => study.included_articles_count
  );
  const completedStudies = completed?.map((study) => study.title);
  const completedArticlesCount = completed?.map(
    (study) => study.articles_count
  );
  const completedAbstractArticlesCount = completed?.map(
    (study) => study.abstract_articles_count
  );
  const completedFulltextArticlesCount = completed?.map(
    (study) => study.fulltext_articles_count
  );
  const completedIncludeArticlesCount = completed?.map(
    (study) => study.included_articles_count
  );

  const renderContent = () => {
    switch (activeTab) {
      case "review":
        return <Reviewcard />;
      case "progress":
        return (
          <Progressgraph
            studies={studies}
            articlesCount={articlesCount}
            abstractArticlesCount={abstractArticlesCount}
            fullTextAriclesCount={fullTextArticlesCount}
            includedArticlesCount={includedArticlesCount}
          />
        );
      case "recentlyCompleted":
        return (
          <RecentlyCompleted
            studies={completedStudies}
            articlesCount={completedArticlesCount}
            abstractArticlesCount={completedAbstractArticlesCount}
            fullTextAriclesCount={completedFulltextArticlesCount}
            includedArticlesCount={completedIncludeArticlesCount}
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <div className="container-fluid" style={{ padding: "0" }}>
          <div ref={contentRef} className="page--content">
            <div
              className="page--heading"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2 style={{ margin: 0 }}>Active Reviews</h2>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  className="tab-icons"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <TbChartBar
                    size={25}
                    className={`tab-icon ${activeTab === "review" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("review")}
                  />
                  <TbChartDots
                    size={25}
                    className={`tab-icon ${activeTab === "progress" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("progress")}
                  />
                  <TbChartArrows
                    size={25}
                    className={`tab-icon ${activeTab === "recentlyCompleted" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("recentlyCompleted")}
                  />
                </div>
                {userData == "admin" ?
                  null : <Link
                    to="/addreview"
                    className="tem--add--btn "
                    style={{ marginLeft: "20px" }}
                  >
                    + Add New
                  </Link>}

              </div>
            </div>

            <div className="tabbed-view">
              {/* Content based on the selected tab */}
              <div className="tab-content">{renderContent()}</div>
            </div>

            <Review />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
